import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/modern-minimal/components/ModernMinimalViewer.tsx");
